import { useBidding } from 'Context/BiddingContext';
import type { StateSlug } from 'Types/enquiryStates';
import { ForSaleCategory } from 'Types/enquiryStates';

interface UseBidCountParams {
	id: number;
	state?: { slug: StateSlug };
}

export const useBidCount = ({
	id,
	state,
}: UseBidCountParams): {
	bidCount?: number;
	shouldShowBidCount: boolean;
} => {
	const { vehiclesBidData } = useBidding();
	const isLiveSaleVehicle = state?.slug === ForSaleCategory.saleActive;
	const bidCount = vehiclesBidData?.[id]?.bidCount;
	const hasBidCount = bidCount !== undefined;
	const shouldShowBidCount = isLiveSaleVehicle && hasBidCount;

	return {
		bidCount,
		shouldShowBidCount,
	};
};
